import { Profile } from '@zapier/shared-entities';

export default function shouldRouteToStandaloneReporting(state) {
  const currentProfile = Profile.selectors.all.currentProfile(state);

  return (
    Profile.selectors.isSwitchOn('mm_reporting_next_opt-in', currentProfile) &&
    !Profile.selectors.isSwitchOn('mm_reporting_next_opt-out', currentProfile)
  );
}
